import { SessionModel as Model } from './Model'


export const MODULE_NAME = 'sessions'

export const SESSIONS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
} as const

export const MENU = {
  id: SESSIONS_ROUTES.LAYOUT,
  route: { name: SESSIONS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-cookie',
} as const
